import type { TChartSeries } from 'components/StackedChart/types'
import type { TRGBAColorWithOpacityAtTheEnd } from 'settings/colors'
import { alphaColorReplacer } from 'settings/colors'

export const makeCompareSeasonsSeriesFromRegularSeries = (
  baseSeries: TChartSeries & { color?: TRGBAColorWithOpacityAtTheEnd },
  comparisonSeries: Partial<TChartSeries>,
): TChartSeries => {
  const colorObjectToUse = comparisonSeries.color
    ? { color: comparisonSeries.color }
    : baseSeries.color && { color: alphaColorReplacer(baseSeries.color, 0.4) }

  return {
    ...baseSeries,
    // IMPORTANT: keep these overrides in sync with generateSeriesForEnvironmentalChart
    ...colorObjectToUse,
    fillOpacity: 0.3,
    hideFromTooltip: true,
    id: `${baseSeries.id}_compareSeasons`,
    linkedTo: baseSeries.id,
    showInLegend: false,
    /**
     * setting zones as an empty array removes dotted forecast lines. This
     * can't be universalized, but easiest way to do it without bringing
     * in an adjusted latestNonForecast timestamp
     */
    zones: [],
    ...comparisonSeries,
  } as TChartSeries
}
